import { useMutation } from '@apollo/client'
import { Button, Typography } from '@material-ui/core'
import React, { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

import { FIX_MANUAL_CANCEL_MUTATION } from '../../graphql/inventoryAllocateAvailability'
import { gregorianToJalaali } from '../../helpers/date'
import { getTranslate, lang } from '../../localization'
import { AllocationMismatch } from '../../types/allocateMismatch'
import ReservationNumbersModal from './ReservationNumbersModal'
import useStyles from './styles/MismatchTable.styles'

interface MismatchRowProps {
  data: AllocationMismatch
}

const MismatchRow: React.FC<MismatchRowProps> = ({ data }) => {
  const classes = useStyles()
  const [reservationNumberModalIsOpen, setreservationNumberModalIsOpen] =
    useState(false)
  // Extract the reservation number from the notes string
  const extractReservationNumber = useCallback((notes: string) => {
    const match = notes.match(/Booking (\d+)/)
    return match ? match[1] : null
  }, [])

  const reservationNumber = extractReservationNumber(data.notes)

  // Check if the mismatch type is "Manual Cancellation Found"
  const isFixButtonEnabled =
    data.mismatchType === 'Manual Cancellation Found' && reservationNumber

  // Mutation hook
  const [fixManualCancel] = useMutation(FIX_MANUAL_CANCEL_MUTATION, {
    // Notify on network status change
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      // Handle success: refetch data or show success toast
      toast.success('Manual cancellation fixed successfully!')
    },
    onError: (error) => {
      // Handle error: show error toast
      toast.error(error.message)
      console.error('Error fixing manual cancellation:', error)
    }
  })

  // Handle the button click
  const handleFixClick = () => {
    if (isFixButtonEnabled && reservationNumber) {
      fixManualCancel({
        variables: { reservationNumber }
      })
    } else {
      setreservationNumberModalIsOpen(true)
    }
  }

  return (
    <div>
      <div className={classes.tableRow}>
        <Typography variant="h4">{data.roomType}</Typography>
        <Typography variant="h4">
          {lang === 'fa' ? gregorianToJalaali(data.date) : data.date}
        </Typography>
        <Typography variant="h4">{data.CRSTotalAllocate}</Typography>
        <Typography variant="h4">{data.sumOfChannelAllocates}</Typography>
        <Typography variant="h4">{data.mismatchType}</Typography>
        <Typography variant="h4">{data.notes}</Typography>
        {/* Conditionally render the button with onClick to trigger mutation */}
        <Button
          variant="contained"
          color="primary"
          // disabled={!isFixButtonEnabled}
          onClick={handleFixClick} // Trigger mutation on click
        >
          {getTranslate(isFixButtonEnabled ? 'Fix' : 'View Bookings')}
        </Button>
      </div>
      {reservationNumberModalIsOpen && (
        <ReservationNumbersModal
          data={data}
          isOpen={reservationNumberModalIsOpen}
          onClose={() => setreservationNumberModalIsOpen(false)}
        />
      )}
    </div>
  )
}

export default MismatchRow
